import {
  faCircleExclamation,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Used to display inline warning/error messages
 * (if not error) can be hidden through the ignore button
 * @param isError changes the icon and text color, cannot be hidden
 * @param warningMessage the message to be displayed
 * @param hidden whether or not the message is hidden
 * @param setHidden function to set hidden attribute
 */
const GenericWarningMessage = (props: {
  isError: boolean;
  warningMessage: string;
  hidden: boolean;
  setHidden: () => void;
}) => {
  return (
    <div
      className={`tw-flex tw-items-start tw-pt-[4px] ${
        props.isError ? "tw-text-red-1" : "tw-text-orange-1"
      } ${props.hidden ? "tw-hidden" : ""}`}
    >
      {props.isError ? (
        <FontAwesomeIcon
          fontSize={16}
          icon={faTriangleExclamation}
          className="tw-pr-[4px] tw-text-red-1"
        />
      ) : (
        <FontAwesomeIcon
          fontSize={16}
          icon={faCircleExclamation}
          className="tw-pr-[4px] tw-text-orange-1"
        />
      )}
      {props.warningMessage}
      {!props.isError && (
        <button
          className="tw-text-blue-500 tw-border-none tw-bg-transparent tw-underline"
          onClick={() => props.setHidden()}
        >
          Ignore
        </button>
      )}
    </div>
  );
};

export default GenericWarningMessage;
